/*
 * ПАНЕЛИЙН ХЭЛ — ДЭЛГЭЦИЙН хэл, КОНТЕНТЫН хэлтэй ХОЛБООГҮЙ.
 *
 * ! `views/apps/website/locale-tabs.tsx`-ийн `LOCALE_NAMES` (mn·en·ko) нь САЙТАД
 * ! нийтлэгдэх МЭДЭЭНИЙ хэл — өгөгдлийн талбар. Энэ файл нь ХЭРЭГЛЭГЧИЙН ХАРДАГ
 * ! ПАНЕЛИЙН хэл. Хоёрыг нэгтгэж болохгүй: сайтад кореор мэдээ нийтлэх хүн
 * ! панелиа монголоор хардаг, мөн эсрэгээр.
 */
export const UI_LOCALES = ['mn', 'en'] as const

export type UiLocale = (typeof UI_LOCALES)[number]

/**
 * Анхдагч бөгөөд ЭХ хэл.
 *
 * ! `mn.json` нь ЭХ БИЧВЭР. Орчуулга дутсан үед энэ хэл нь нөөц болно
 * ! (`lang/dictionary.ts`) — тиймээс монгол мөр устгах нь бүх хэлийг эвднэ.
 */
export const DEFAULT_UI_LOCALE: UiLocale = 'mn'

/** Хэл сэлгэгчид гарах нэр — хэл бүр ӨӨРИЙН хэлээрээ бичигдэнэ. */
export const UI_LOCALE_NAMES: Record<UiLocale, string> = {
  mn: 'Монгол',
  en: 'English'
}

/*
 * COOKIE, `localStorage` БИШ — `contexts/settingsContext.tsx`-ийн дүрмийн дагуу.
 *
 * ! Гурван шалтгаан:
 * ! ① `(blank)` доторх нэвтрэх дэлгэц СЕРВЕР дээр зурагддаг. `localStorage`-ийг
 * !   mount болтол уншиж болдоггүй тул англиар сонгосон хүн монгол хуудас
 * !   харангуутаа англи болж «мяраадаг». Cookie-г `app/layout.tsx` сервер дээр
 * !   уншиж чадна.
 * ! ② `<html lang>`-ыг `app/layout.tsx` энэ cookie-гоос (`lib/html-lang.ts`) сервер дээр
 * !   тодорхойлно — `localStorage` серверт хүрдэггүй.
 * ! ③ Cookie нь API руу хамт явдаг тул серверийн мессежийг ижил сонголтоор
 * !   хөрвүүлэх зам нээлттэй үлдэнэ.
 */
export const LOCALE_COOKIE = 'coresoft.locale'

/** Танихгүй cookie-гийн утгыг панел ЗУРЖ ЧАДАХ хэл болгож нарийсгана. */
export const parseUiLocale = (value: string | undefined | null, fallback: UiLocale = DEFAULT_UI_LOCALE): UiLocale =>
  UI_LOCALES.includes(value as UiLocale) ? (value as UiLocale) : fallback

/**
 * Хөтчийн cookie-гоос хэлийг уншина.
 *
 * ! Сервер дээр (`document` алга) ҮРГЭЛЖ анхдагчийг буцаана. Тиймээс серверийн
 * ! HTML нь монголоор, хөтөч нь сонгосон хэлээр зурагдах зөрүү гарч болно —
 * ! панелийн бүрхүүл `<Authenticated>` дотор байгаа тул тэнд зөрүү ҮҮСЭХГҮЙ
 * ! (серверийн HTML бол зөвхөн spinner), харин нэвтрэх дэлгэцэд үүснэ.
 * ! `app/layout.tsx` нь cookie-г уншиж `<html lang>`-ыг зөв тавьдаг ч (`lib/html-lang.ts`),
 * ! нэвтрэх дэлгэцийн ТЕКСТ энэ функцээр орчуулагддаг тул серверийн зураглал монгол хэвээр.
 */
export const readUiLocale = (): UiLocale => {
  if (typeof document === 'undefined') return DEFAULT_UI_LOCALE

  const match = new RegExp(`(?:^|;\\s*)${LOCALE_COOKIE}=([^;]*)`).exec(document.cookie)

  return parseUiLocale(match?.[1] ? decodeURIComponent(match[1]) : undefined)
}

/** Сонголтыг НЭГ ЖИЛ хадгална — `lib/view-preference.ts`-ийн ижил хэлбэр. */
export const rememberUiLocale = (locale: UiLocale) => {
  document.cookie = `${LOCALE_COOKIE}=${locale}; path=/; max-age=31536000; samesite=lax`
}
